/*
 * View for Reports Page
 */

define([
  "marionette",
  "highcharts/highcharts",
  "jquery",
  "modules/reportSplit/reports/template/reportsTemplate.html",
  "messaging/messenger",
], function (Marionette, Highcharts, $, ReportsTemplate, Messenger) {
  "use strict";

  const ReportsView = {};

  //set up the layout
  ReportsView.reportsLayout = Marionette.Layout.extend({
    template: ReportsTemplate,
    configVisible: true,
    regions: {
      reportDiv: "#reportDiv",
      configDiv: "#configDiv",
      //reportDisplay
    },

    events: {
      'click [id="aReportGroup"]': "clickedReportGroup",
      'click [id="btnShow"]': "showOrHideConfigurationDiv",
    },

    clickedReportGroup: function () {
      console.log("clicked on aReportGroup");
      Messenger.vent.trigger("show:reports");
    },

    hideConfiguration: function () {
      this.$el.find("#configDiv").hide();
      this.$el.find("#configDiv").removeClass("span3");
      this.$el.find("#reportDiv").removeClass("span9");
      this.$el.find("#reportDiv").addClass("span12");
    },

    hideConfigurationButton: function () {
      this.$el.find("#configSpan").hide();
    },

    showConfiguration: function () {
      this.$el.find("#configDiv").show();
      this.$el.find("#configDiv").addClass("span3");
      this.$el.find("#reportDiv").removeClass("span12");
      this.$el.find("#reportDiv").addClass("span9");
    },

    showConfigurationButton: function () {
      this.$el.find("#configSpan").show();
    },

    showOrHideConfigurationDiv: function () {
      if (this.configVisible) {
        this.hideConfiguration();
        $(window).trigger("resize");
        this.configVisible = false;
        //$('#btnShow').removeClass('active');
        this.$el.find("#btnShow").addClass("btn-astute");
        this.$el.find("#btnShow").text($.t("reports.showConfiguration"));
      } else {
        this.showConfiguration();
        $(window).trigger("resize");
        this.configVisible = true;
        //$('#btnShow').addClass('active');
        this.$el.find("#btnShow").removeClass("btn-astute");
        this.$el.find("#btnShow").text($.t("reports.hideConfiguration"));
      }
      this.resizeCharts();
    },
    updateHeader: function (text) {
      this.$el.find("#spnReportHeader").html(text);
    },
    updateSubheader: function (text) {
      this.$el.find("#spnReportSubHeader").html(text);
    },
    resizeCharts: function () {
      // Triggering 'resize' on the window will properly adjust the wrappers for each chart, but for some reason, the
      // chart div itself is not affected. So this function will call 'reflow' on each chart which will resize it to fit
      // the parent div
      const areas = ["west", "center", "east", "southwest", "south", "southeast"];
      for (let i = 0; i < areas.length; i++) {
        const highchart = Messenger.reqres.request("report:area:highcharts:data", areas[i]);
        if (highchart !== undefined) {
          highchart.reflow();
        }
      }
    },
  });

  return ReportsView;
});
